import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Layout from "../components/layout";
import GithubCorner from "../components/GithubCorner";
import { UtterancesComments } from "@/components/utterances";
import Bio from "../components/Bio";
import SEO from "../components/seo";
import Helmet from "react-helmet";
import "./friends.scss";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout location="friends">
  <article className="prose dark:prose-invert">{children}</article>
</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <GithubCorner url="https://github.com/yujinyan/blog/issues/46" mdxType="GithubCorner" />
    <Helmet htmlAttributes={{
      lang: "en"
    }} mdxType="Helmet" />
    <SEO title="Friends 友链 | Yu Jinyan's Blog" mdxType="SEO" />
    <h1 {...{
      "id": "friends--span-langzh-cmn-hans友链span",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#friends--span-langzh-cmn-hans%E5%8F%8B%E9%93%BEspan",
        "aria-label": "friends  span langzh cmn hans友链span permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Friends | `}<span lang="zh-cmn-Hans">{`友链`}</span></h1>
    <p>{`Most authors nowadays publish their articles on platforms like WeChat, Juejin, or Medium.
Unfortunately, their content sometimes gets lost in a sea of clickbaity ads
that try to sell you programming tutorials by exploiting people’s anxieties.
Even worse, many articles are locked inside a `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Closed_platform"
      }}>{`walled garden`}</a>{`.`}</p>
    <p>{`It’s delightful to see there are still people out there,
tinkering with technologies of the Open Web and presenting their passion with a personal touch.`}</p>
    <p>{`This is a compilation of such personal blog sites that I have come across and found inspiring.
I hope this list can help you discover more sites like this one.`}</p>
    <h3 {...{
      "id": "stay-hungry-stay-foolish---edward-elrics-blog",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#stay-hungry-stay-foolish---edward-elrics-blog",
        "aria-label": "stay hungry stay foolish   edward elrics blog permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h3" {...{
        "href": "https://edward40.com/"
      }}>{`Stay Hungry Stay Foolish - Edward Elric’s Blog`}</a></h3>
    <p><em parentName="p">{`Web Development, Rust, Programming Languages.`}</em>{`
I am a simple person. Whenever I see a site with that gorgeous Novela theme,
I try to add it to this list ;-).`}</p>
    <h3 {...{
      "id": "prin-blog",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#prin-blog",
        "aria-label": "prin blog permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h3" {...{
        "href": "https://printempw.github.io"
      }}>{`Prin Blog`}</a></h3>
    <p><em parentName="p">{`Fullstack Development.`}</em>{`
Prin says he’s obsessed with layout and typography. I can testify to that.`}</p>
    <h3 {...{
      "id": "island---youngxhuis-blog",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#island---youngxhuis-blog",
        "aria-label": "island   youngxhuis blog permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h3" {...{
        "href": "https://youngxhui.top/posts/"
      }}>{`Island - youngxhui’s blog`}</a></h3>
    <p>{`We share a lot of interests (e.g. Kotlin) and blogged about several common topics.`}</p>
    <h3 {...{
      "id": "luyu-huangs-tech-blog",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#luyu-huangs-tech-blog",
        "aria-label": "luyu huangs tech blog permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h3" {...{
        "href": "https://luyuhuang.tech/"
      }}>{`Luyu Huang’s Tech Blog`}</a></h3>
    <p>{`Luyu Huang is a software engineer and game developer.
His blog features topics on programming, algorithm, mathematics, game design etc.`}</p>
    <h3 {...{
      "id": "dorcks-blog",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#dorcks-blog",
        "aria-label": "dorcks blog permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h3" {...{
        "href": "https://dorck.cn/"
      }}>{`Dorck’s Blog`}</a></h3>
    <p>{`道轲：编程语言/开源/极客路上的初行者。Kotlin, Android.`}</p>
    <hr />
    <blockquote>
      <p parentName="blockquote">{`Feel your site belongs to this list? Contact me or leave a comment below.
You can also edit `}<a parentName="p" {...{
          "href": "https://github.com/yujinyan/blog/blob/master/src/pages/friends.mdx"
        }}>{`this page`}</a>{`
and send a `}<span parentName="p" {...{
          "className": "smcp"
        }}>{`PR`}</span>{` directly.`}</p>
    </blockquote>
    <Bio mdxType="Bio" />
    <UtterancesComments issueId={46} className="mt-16" mdxType="UtterancesComments" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      